module.exports = __webpack_public_path__ + "static/media/global-cny.2b137c6c.png";